import Button from '../Button/Button';
import { ButtonColor, ButtonAlign, ShowIcon } from '../Button/consts';
import { ClickableAction } from '../Clickable/consts';
import { ContainerSize, ContainerChildrenSpace } from '../Container/consts';
import Container from '../Container/Container';
import {
  HeadlineColor,
  HeadlineLevel,
  HeadlineAlign,
} from '../Headline/consts';
import Headline from '../Headline/Headline';
import HStack from '../HStack/HStack';
import JobList from '../JobList/JobList';
import { SectionVariant, SectionBackgroundColor } from '../Section/consts';
import Section from '../Section/Section';
import type { JobRelatedJobsSectionProps } from './interfaces';
import styles from './JobRelatedJobsSection.module.scss';

const JobRelatedJobsSection = ({
  headline,
  jobs,
  searchParams,
  isFavorite,
  toggleFavorite,
}: JobRelatedJobsSectionProps) => {
  return (
    <Section
      id="related-jobs"
      variant={SectionVariant.LargePadding}
      bgColor={SectionBackgroundColor.Violet}
    >
      <Container
        size={ContainerSize.Small}
        spaceBetweenChildren={ContainerChildrenSpace.Small}
      >
        <Headline
          headlineColor={HeadlineColor.Dark}
          level={HeadlineLevel.Two}
          align={HeadlineAlign.Center}
          className={styles.relatedJobsHeadline}
        >
          {headline}
        </Headline>
        <HStack justify="center">
          <JobList
            jobs={jobs.slice(0, 3)}
            isFavorite={isFavorite}
            toggleFavorite={toggleFavorite}
            styleVariant="borderBetween"
            hasItemPadding={false}
          />
        </HStack>
        {jobs.length > 3 && (
          <Button
            color={ButtonColor.Primary}
            align={ButtonAlign.Center}
            actionType={ClickableAction.Linkextern}
            linkextern={`/karriere/jobsuche${searchParams}`}
            showIcon={ShowIcon.ShowIcon}
            icon={'action/arrow-right'}
          >
            Weitere Stellen anzeigen
          </Button>
        )}
      </Container>
    </Section>
  );
};

export default JobRelatedJobsSection;
